<div class="game-icon" 
    [ngStyle]="{
        'width': sizeCss,
        'height': sizeCss
    }">
    <img [src]="gameIcon" alt="{{ game }} icon" />
</div>
